import store from "../Store/configureStore";
import * as actions from "../Store/Actions/index";
import { defaultRoles } from "../Store/Reducers/costs";
const lodash = require("lodash");

/**
 * Data cleaner method for role object.
 */
const getFilteredRoleObject = (obj) => {
  return lodash.pick(obj, ["role", "name", "plural", "number", "wage", "benefit", "hours"]);
};

/**
 * Data cleaner method for system cost object.
 */
const getFilteredSystemCostObject = (obj) => {
  return lodash.pick(obj, [
    "one-time-software-installation-cost",
    "annual-fee",
    "number-it-personnel",
    "wage-it-personnel",
    "hourly-benefit-amount",
    "retraining-hours",
    "other-system-cost",
  ]);
};

/**
 * Data cleaner method for productivity loss object
 */
const getFilteredProdLossCostObject = (obj) => {
  return lodash.pick(obj, [
    "working-hours-per-day",
    "min-break-in-period",
    "max-break-in-period",
    "working-days-per-month",
    "coding-time-a",
    "coding-time-b",
  ]);
};

/**
 * Data cleaner method for cost adjustment object
 */
const getFilteredCostAdjustObject = (obj) => {
  return lodash.pick(obj, ["inflation-rate", "years-into-future"]);
};

/**
 * Data cleaner method for benefits object
 */
const getFilteredBenefitObject = (obj) => {
  return lodash.pick(obj, [
    "auto-coding",
    "vendor-costs-savings",
    "travel-saving",
    "accurate-billing-saving",
    "reduced-claims-savings",
    "other-savings",
  ]);
};

export const downloadData = async () => {
  const state = store.getState();

  const data = {};

  data["currency"] = lodash.get(state, "currency.currency");
  data["roles"] = lodash.get(state, "costs.retrainCostDetails.roles").map((obj) => getFilteredRoleObject(obj));
  data["otherRetrainCost"] = lodash.get(state, "costs.retrainCostDetails.othercosts");
  data["systemCosts"] = getFilteredSystemCostObject(lodash.get(state, "costs.systemCostDetails"));
  data["productivityLoss"] = getFilteredProdLossCostObject(lodash.get(state, "costs.prodLossDetails"));
  data["costAdjustments"] = getFilteredCostAdjustObject(lodash.get(state, "costs.costAdjustDetails"));
  data["benefits"] = getFilteredBenefitObject(lodash.get(state, "benefits.benefitsDetails"));

  const json = JSON.stringify(data);
  const blob = new Blob([json], { type: "application/json" });
  const href = await URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = "icd_calculator_data.json";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const uploadData = () => {
  const input = document.createElement("input");
  input.type = "file";

  input.onchange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsText(file, "UTF-8");
    reader.onload = (readerEvent) => {
      const content = readerEvent.target.result;
      processUploadData(content);
    };
  };
  input.click();
};

const setRequiredOnRoleObject = (roleObj) => {
  const requiredRoles = defaultRoles.filter((obj) => obj.required === true).map((obj) => obj.role);

  if (requiredRoles.includes(roleObj.role)) {
    roleObj.required = true;
  }

  return roleObj;
};

const processUploadData = (dataString) => {
  var data = {};
  try {
    data = JSON.parse(dataString);
    const roles = lodash
      .get(data, "roles")
      .map((obj) => getFilteredRoleObject(obj))
      .map((obj) => setRequiredOnRoleObject(obj));

    const otherRetrainCost = lodash.get(data, "otherRetrainCost");

    const retrainCostDetails = { roles, othercosts: otherRetrainCost };

    const currency = lodash.get(data, "currency");

    const prodLossDetails = lodash.get(data, "productivityLoss");
    const systemCostDetails = lodash.get(data, "systemCosts");
    const costAdjustDetails = lodash.get(data, "costAdjustments");
    const benefitsDetails = lodash.get(data, "benefits");

    store.dispatch(actions.setCurrency(currency));
    store.dispatch(actions.setRetrainCostDetail(retrainCostDetails));
    store.dispatch(actions.setProdLoss(prodLossDetails));
    store.dispatch(actions.setSystemCost(systemCostDetails));
    store.dispatch(actions.setCostAdjust(costAdjustDetails));
    store.dispatch(actions.setBenefits(benefitsDetails));
  } catch (error) {
    alert("Invalid file");
  }
};

export const disabledTabIds = [
  "othercosts",
  "working-days-per-month",
  "other-system-cost",
  "other-savings",
  "years-into-future",
  "showBenefits",
  "retrainingOtherPanel",
  "timelinePanel",
  "otherSystemCostsPanel",
];

export const disabledShiftTabIds = ["prevButton", "largeMenu", "download", "upload", "currency", "pdf", "clear"];
